"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GregorianDate = void 0;
const DateHelpers = __importStar(require("../dateHelpers"));
const Constants = __importStar(require("../constant"));
const DateBase_1 = require("./DateBase");
const MIN_DAY = 1;
const MAX_DAY = 31;
const MIN_MONTH = 1;
const MAX_MONTH = 12;
const ISO_8601_DATE_REGEX = /^(\d{4})-([01]\d)-([0-3]\d)$/;
const TWO_DIGITS = 10;
/**
 * Represents a date in the Gregorian calendar. Not a specific moment in time.
 */
class GregorianDate extends DateBase_1.DateBase {
    /**
     * Creates a new instance of the GregorianDate class.
     *
     * @param year - The year value.
     * @param month - The month value.
     * @param day - The day value.
     *
     * @throws {Error} - If the day or month values are invalid.
     */
    constructor(year, month, day) {
        super();
        /**
         * Validates the input of the gregorianDate
         *
         * @param year - The year value.
         * @param month - The month value.
         * @param day - The day value.
         *
         * @throws {Error} - If the day or month values are invalid.
         *
         * @returns {void}
         */
        this.validate = (month, day) => {
            if (day < MIN_DAY || day > MAX_DAY) {
                throw new Error('Gregorian Date - Invalid day');
            }
            if (month < MIN_MONTH || month > MAX_MONTH) {
                throw new Error('Gregorian Date - Invalid month');
            }
        };
        /**
         * Creates a new instance of the GregorianDate class from a JS Date object.
         *
         * @param date - The JS Date object.
         *
         * @returns {GregorianDate} - The GregorianDate instance representing the same date as the input date.
         */
        this.fromDate = (date) => GregorianDate.fromDate(date);
        /**
         * Creates a new instance of the GregorianDate class from an ISO-8601 string.
         *
         * @param str - The ISO-8601 string representation of the date.
         *
         * @returns {GregorianDate} - The GregorianDate instance representing the date parsed from the input string.
         */
        this.fromISOString = (str) => GregorianDate.fromISOString(str);
        /**
         * Returns a JS Date object representing the GregorianDate instance.
         *
         * @returns {Date} - The JavaScript Date object representing the same date as the GregorianDate instance.
         */
        this.toDate = () => new Date(this.year, this.month - 1, this.day);
        /**
         * Converts the GregorianDate instance to a full ISO 8601 date string.
         *
         * @returns {string} - A string representing the GregorianDate in full ISO 8601 format (YYYY-MM-DD).
         */
        this.toISOString = () => `${this.year}-${this.month < TWO_DIGITS ? '0' + this.month : this.month}-${this.day < TWO_DIGITS ? '0' + this.day : this.day}`;
        /**
         * Checks if the current GregorianDate instance is equal to the specified date.
         *
         * @param date - The GregorianDate instance to compare.
         *
         * @returns {boolean} - True if the current GregorianDate instance is equal to the specified date, false otherwise.
         */
        this.isEqual = (date) => this.year === date.year && this.month === date.month && this.day === date.day;
        /**
         * Checks if the current GregorianDate instance is equal to the specified date, only comparing the date part (day, month, year).
         *
         * @param date - The GregorianDate instance to compare.
         *
         * @returns {boolean} - True if the current GregorianDate instance is equal to the specified date, false otherwise.
         */
        this.isEqualDate = (date) => this.year === date.year && this.month === date.month && this.day === date.day;
        /**
         * Checks if the current GregorianDate instance is in the same year as the specified date.
         *
         * @param date - The GregorianDate instance to compare.
         *
         * @returns {boolean} - True if the current GregorianDate instance is in the same year as the specified date, false otherwise.
         */
        this.isThisYear = (date) => this.year === date.year;
        /**
         * Checks if the current GregorianDate instance is in the same month as the specified date.
         *
         * @param date - The GregorianDate instance to compare.
         *
         * @returns {boolean} - True if the current GregorianDate instance is in the same month as the specified date, false otherwise.
         */
        this.isThisMonth = (date) => this.year === date.year && this.month === date.month;
        /**
         * Gets the name of the month based on the month index.
         *
         * @param format - The format of the month name (optional, default: LONG).
         *
         * @returns {string} - The name of the month.
         */
        this.getMonthNameByMonthIndex = (format = Constants.LONG) => DateHelpers.getMonthNameByMonthIndex(this.month, format);
        this.validate(month, day);
        this.day = day;
        this.month = month;
        this.year = year;
    }
}
exports.GregorianDate = GregorianDate;
/**
 * Creates a new instance of the GregorianDate class from a JS Date object.
 *
 * @param date - The JS Date object.
 *
 * @returns {GregorianDate} - The GregorianDate instance representing the same date as the input date.
 */
GregorianDate.fromDate = (date) => new GregorianDate(date.getFullYear(), date.getMonth() + 1, date.getDate());
/**
 * Creates a new instance of the GregorianDate class from an ISO-8601 string.
 *
 * @param str - The ISO-8601 string representation of the date.
 *
 * @returns {GregorianDate} - The GregorianDate instance representing the date parsed from the input string.
 */
GregorianDate.fromISOString = (str) => {
    const match = str.match(ISO_8601_DATE_REGEX);
    if (match) {
        const [, year, month, day] = match;
        return new GregorianDate(Number.parseInt(year, 10), Number.parseInt(month, 10), Number.parseInt(day, 10));
    }
    throw new Error(`Expected ISO 8601 date, got ${str}`);
};
/**
 * Gets the current Gregorian date.
 *
 * @returns {GregorianDate} - The GregorianDate instance representing today.
 */
GregorianDate.today = () => GregorianDate.fromDate(new Date());
//# sourceMappingURL=GregorianDate.js.map